import React from "react";

const Assetinsight = () => {
  return (
    <div>
      <h1>Assetinsight Deatails</h1>
    </div>
  );
};

export default Assetinsight;
